import { useMutation } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { trackError } from "app/pages/sales-intelligence/utils/errors/tracking";

export const useIndustryTransitionSendEmailMutation = () =>
    useMutation({
        mutationFn: () => salesApiService.industry.sendContactEmail(),
        retry: false,
        onError: trackError,
    });
